import React from 'react'
import { useRouter } from 'next/router'
import { Elements } from '@stripe/react-stripe-js'
import { useTenantContext } from 'context/TenantContext'
import SpinnerImage from 'components/Spinners/spinner-image'

function StripeIntegration({ children }: any) {
    const router = useRouter()
    const { stripe_promise } = useTenantContext()

    const requires_tenant = router.pathname.startsWith('/dashboard') || router.pathname.startsWith('/book/') || router.pathname.startsWith('/kiosk')

    if (requires_tenant) {
        return (
            <>
                {stripe_promise ? (
                    <Elements stripe={stripe_promise}>{children}</Elements>
                ) : (
                    <div className={`fixed top-1/2 left-1/2 -translate-x-8 -translate-y-8`} style={{ zIndex: 998 }}>
                        <div className='flex items-center'>
                            <SpinnerImage />
                        </div>
                    </div>
                )}
            </>
        )
    }

    return <>{children}</>
    
}

export default StripeIntegration
